module.exports = __webpack_public_path__ + "img/guarantee.05d964e7.png";